import React from 'react'
import CubeIcon from '../../../../assets/icon/cube.svg'

function Cube() {
    return (
        <>
            <img className='w-6 h-auto -mt-4' src={CubeIcon} alt="cube" />
        </>
    )
}

export default Cube